import React, { Component } from "react";
import Progress from "./CustomTool/Progress";
import { Grid, Box, CardContent, CardMedia } from "@mui/material";
import CtTxt from "./CustomTool/CtTxt";
import CtDtp from "./CustomTool/CtDtp";
import CtCmb from "./CustomTool/CtCmb";
import TextAreaAutoSize from "./CustomTool/TextAreaAutoSize";
import CtBtn from "./CustomTool/CtBtn";
import { Edit, Delete, ThirtyFpsSharp } from "@mui/icons-material";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { withRouter } from "../HOC/withRouter";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import { fetchLoadUnload } from "./API";
import {
  get_YMD_from_SYS,
  get_30DaysBack_FromCurrentDate,
  validatedate_min_max,
  getlocalstoragedate,
  setlocalstoragedate,
} from "../SystemUtility/SystemUtility";
import TableList from "./CustomTool/TableList";
import VehicleUnload from "./VehicleUnload";
import ResetDate from "../images/resetdate.png";

class VehicleLoadUnloadList extends Component {
  state = {
    LoadingSrNo: [],
    Packing: [],
    TaxName: [],
    autoEnableDisalbe_Col_Info: [],
    formData: {
      dtpFromDate: "",
      dtpToDate: "",
    },
    columns: [
      { id: "Action", label: "Search", name: "Search" },
      { id: "bint_loadingsrno", label: "Loading Sr. No." },
      { id: "dat_loaddateDMY", label: "Loading Date" },
      { id: "vac_storename", label: "Loading Store" },
      { id: "vac_ledgername", label: "Delivery Responsible Person" },
    ],
    rows: [],
    actionList: [
      {
        name: "Edit",
        icon: <Edit />,
        link: "VehicleLoadUnloadList:",
        actionType: "AlertResponsive",
      },
      {
        name: "Delete",
        icon: <Delete />,
        link: "VehicleLoadUnloadList:",
        actionType: "AlertResponsive",
        visiblecondition: [
          { colID: "DisableDelete", value: false, relationalOperator: "==" },
        ],
      },
    ],
    searchData: {
      bint_loadingsrno: "",
      dat_loaddateDMY: "",
      vac_storename: "",
      vac_ledgername: "",
    },
    rowsCount: 0,
    rowsPerPage: 50,
    counter: 0,
    keyColumn: [
      "bint_loadingsrno",
      "dat_loaddateDMY",
      "vac_storename",
      "vac_ledgername",
      "bint_acid",
      "bint_acyear",
    ],
    searchColumns: [],
    searchRows: [],
    searchOpen: false,
    searchRowsCount: 0,
    dataLoadStatus: true,
    ARD: null,
  };

  //#region Component
  componentDidMount() {
    document.title = "RA : Loading List";
    this.props.setActiveMenu("VehicleUnload");
    this.setSearchColumns();
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
    // this.onFormload();
  }
  //#endregion Component

  DeleteLoadingEntry = (
    bint_acid,
    bint_loadingsrno,
    bint_acyear,
    vac_storename
  ) => {
    let dataLoadStatus = false;
    this.props.notifyProcessing();
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "DeleteLoadingEntry",
        bint_acyear: bint_acyear,
        bint_acid: bint_acid,
        edit_loadingsrno: bint_loadingsrno,
        dat_fromdate: this.state.formData.dtpFromDate,
        dat_todate: this.state.formData.dtpToDate,
        vac_storename: vac_storename,
      };
      fetchLoadUnload(reqData)
        .then((res) => {
          dataLoadStatus = true;
          this.props.updateProcessing(res.data.msgType, res.data.message);
          if (res.data.msgType === "success") {
            let rows = this.addActionColStatus(res.data.LoadingList);
            this.setState(
              {
                rows,
                dataLoadStatus,
              },
              () => {}
            );
          }
        })
        .catch((error) => {
          console.log("Unknown error occurred in deleteOrderList.", error);
        });
    });
    return true;
  };

  //#region Handle

  NavigateToLoadEntry = (bint_acid, bint_loadingsrno, bint_acyear) => {
    this.props.navigateTo("VehicleLoadEntry", {
      bint_acid: bint_acid,
      bint_loadingsrno: bint_loadingsrno,
      bint_acyear: bint_acyear,
    });
  };

  handleARDonActionClick = (row) => {
    // console.log("values", values);
    const bint_acid = row.bint_acid,
      vac_storename = row.vac_storename,
      bint_loadingsrno = row.bint_loadingsrno,
      bint_acyear = localStorage.getItem("ACY"),
      actionName = row.actionName;
    if (actionName === "Edit") {
      // this.props.navigateTo(
      //   "VehicleLoadEntry/:" +
      //     bint_acid +
      //     ":" +
      //     bint_loadingsrno +
      //     ":" +
      //     bint_acyear
      // );
      this.NavigateToLoadEntry(bint_acid, bint_loadingsrno, bint_acyear);
    } else if (actionName === "Delete") {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want to Delete Loading Sr. No. : " +
              bint_loadingsrno +
              " ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteLoadingEntry(
                bint_acid,
                bint_loadingsrno,
                bint_acyear,
                vac_storename
              );
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    }
  };

  handleOnChange = (e) => {
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        if (e.target.name === "dtpFromDate" || e.target.name === "dtpToDate") {
          this.setfrom_todate();
        }
      }
    );
  };

  handleOnNewEntryClick = () => {
    this.props.navigateTo("VehicleLoadEntry");
  };

  handleOnSearchChange = (searchOpen) => {
    let searchRows = [];
    if (searchOpen === true && this.state.rows.length > 0) {
      this.state.rows.map((row) => {
        if (
          searchOpen === true &&
          (this.state.searchData.bint_loadingsrno.length === 0 ||
            (row["bint_loadingsrno"] &&
              row["bint_loadingsrno"] ==
                this.state.searchData.bint_loadingsrno)) &&
          (this.state.searchData.dat_loaddateDMY.length === 0 ||
            (row["dat_loaddateDMY"] &&
              row["dat_loaddateDMY"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.dat_loaddateDMY.toLowerCase()
                ))) &&
          (this.state.searchData.vac_storename.length === 0 ||
            (row["vac_storename"] &&
              row["vac_storename"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_storename.toLowerCase()
                ))) &&
          (this.state.searchData.vac_ledgername.length === 0 ||
            (row["vac_ledgername"] &&
              row["vac_ledgername"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_ledgername.toLowerCase())))
        ) {
          searchRows.push(row);
        }
      });
      const searchRowsCount = searchRows.length;
      this.setState(
        {
          searchOpen,
          searchRows,
          searchRowsCount,
          counter: this.state.counter + 1,
        },
        () => {}
      );
    } else {
      this.setState({ searchOpen });
    }
  };

  handleOnSearchInputChange = (e) => {
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen);
      }
    );
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleOnChangeAutoEnableDisalbe_ColIdxs = (autoEnableDisalbe_Col_Info) => {
    this.setState({ autoEnableDisalbe_Col_Info });
  };

  handleOnRowDataChange = (rows, handledRowIndex, colID) => {
    this.setState({ rows, rowsCount: rows.length }, () => {});
  };

  //#endregion handle

  setSearchColumns = () => {
    let searchColumns = [];
    searchColumns.push(
      {
        cType: "CtTxt",
        id: "bint_loadingsrno",
        label: "Loading Sr No.",
        value: this.state.searchData.bint_loadingsrno,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "dat_loaddateDMY",
        items: this.state.dat_loaddateDMY,
        label: "Loading Date",
        value: this.state.searchData.dat_loaddateDMY,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_storename",
        items: this.state.vac_storename,
        label: "Loading Store",
        value: this.state.searchData.vac_storename,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_ledgername",
        label: "Delivery Responsible Person",
        value: this.state.searchData.vac_ledgername,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      }
    );
    this.setState({ searchColumns });
  };

  addActionColStatus = (rows) => {
    const newRows = rows.map((row) => {
      const actionStatus = this.DisableOnEditDelete(row.int_status, true);
      return {
        ...row,
        DisableDelete: actionStatus.DisableDelete,
      };
    });
    return newRows;
  };

  DisableOnEditDelete = (int_status, returnStatus = undefined) => {
    let DisableDelete = false;
    if (int_status == 0) {
      DisableDelete = false;
    } else {
      DisableDelete = true;
    }
    if (returnStatus) {
      return {
        DisableDelete,
      };
    } else {
      this.setState(
        {
          DisableDelete,
        },
        () => {}
      );
    }
  };

  validatList = () => {
    let result = false;
    const fromDate = this.state.formData.dtpFromDate;
    const toDate = this.state.formData.dtpToDate;
    if (this.state.formData.dtpFromDate.length <= 0) {
      this.props.toastErrorMsg("Enter Date", "dtpFromDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpFromDate,
        "dtpFromDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return result;
    } else if (this.state.formData.dtpToDate.length <= 0) {
      this.props.toastErrorMsg("Enter Date", "dtpToDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpToDate,
        "dtpToDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return result;
    } else if (new Date(fromDate) > new Date(toDate)) {
      this.props.toastErrorMsg(
        "To Date must be greater than From Date",
        "dtpFromDate"
      );
    } else {
      result = true;
    }
    return result;
  };

  setfrom_todate = (reset = false) => {
    setlocalstoragedate(
      "Loading",
      this.state.formData.dtpFromDate,
      this.state.formData.dtpToDate,
      reset
    );
    if (reset) {
      window.location.reload();
      this.onFormLoad();
    }
  };

  getInfo = () => {
    if (this.validatList()) {
      let dataLoadStatus = false;
      this.setState({ dataLoadStatus }, () => {
        let reqData = {
          Op: "LoadingList",
          bint_acyear: localStorage.getItem("ACY"),
          bint_acid: localStorage.getItem("acid"),
          dat_fromdate: this.state.formData.dtpFromDate,
          dat_todate: this.state.formData.dtpToDate,
          bint_loadingsrno: 0,
        };
        fetchLoadUnload(reqData)
          .then((res) => {
            let rows = this.addActionColStatus(res.data.LoadingList),
              rowsCount = rows.length;
            this.setState(
              {
                dataLoadStatus: true,
                rows,
                rowsCount,
              },
              () => {}
            );
          })
          .catch((error) => {
            this.props.toastMsg(
              "error",
              "Unkonwn Error occured in onFormLoad. " + error
            );
          });
        document.getElementById("dtpFromDate").focus();
      });
    }
  };

  onFormLoad = () => {
    const { fromdate, todate } = getlocalstoragedate("Loading");
    let dtpFromDate = fromdate,
      dtpToDate = todate;
    this.setState(
      {
        formData: {
          ...this.state.formData,
          dtpFromDate,
          dtpToDate,
        },
      },
      () => {
        this.getInfo();
      }
    );
  };

  render() {
    let rows = this.state.searchOpen ? this.state.searchRows : this.state.rows;
    let rowsCount = this.state.searchOpen
      ? this.state.searchRowsCount
      : this.state.rowsCount;
    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        {/* <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "25px", color: "#6f7689" }}>
            <b>Loading List</b>
          </label>
        </Grid> */}
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item style={{ display: "inline-flex" }}>
            <CardContent style={{ paddingBottom: "0px" }}>
              <CardMedia
                component="img"
                alt="Reset Date to Default"
                sx={{ width: 35 }}
                image={ResetDate}
                onClick={() => {
                  this.setfrom_todate(true);
                }}
              />
            </CardContent>
            <CtDtp
              id="dtpFromDate"
              defaultValue={this.state.formData.dtpFromDate}
              value={this.state.formData.dtpFromDate}
              label="Load Date"
              width="150"
              handleOnChange={this.handleOnChange}
              accountYear={localStorage.getItem("ACY")}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="dtpToDate"
            />
          </Grid>
          <Grid item>
            <CtDtp
              id="dtpToDate"
              defaultValue={this.state.formData.dtpToDate}
              label="Load Date"
              width="150"
              accountYear={localStorage.getItem("ACY")}
              value={this.state.formData.dtpToDate}
              handleOnChange={this.handleOnChange}
              onKeyDown={this.props.onKeyDown}
              defaultAction={this.getInfo}
            />
          </Grid>
          <Grid item>
            <CtBtn id="Listbtn" label="List" onClick={this.getInfo} />
          </Grid>
        </Grid>
        <br />

        <TableList
          toastMsg={this.props.toastMsg}
          columns={this.state.columns}
          counter={this.state.counter}
          rows={rows}
          rowsCount={rowsCount}
          rowsPerPage={this.state.rowsPerPage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          handleOnActionClick={this.handleARDonActionClick}
          actionList={this.state.actionList}
          keyColumn={this.state.keyColumn}
          handleOnSearchChange={this.handleOnSearchChange}
          searchColumns={this.state.searchColumns}
          searchData={this.state.searchData}
          provideSearch={true}
          handleOnNewEntryClick={this.handleOnNewEntryClick}
          toolTipNewEntry="Loading Entry"
        />
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(VehicleLoadUnloadList))));
